import { createSelector } from '@reduxjs/toolkit'

export const getRecords = (state) => state.filters

export const getSelectedFilters = createSelector(getRecords, (filtersState) => filtersState.filters)

export const getSelectedCategory = createSelector(getRecords, (filtersState) => filtersState.selectedCategory)
